import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Error, Label } from '@progress/kendo-react-labels';
import { Input, TextArea } from '@progress/kendo-react-inputs';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';

import { Timeline } from '../../../contexts/reels';

export const TimelineTextEditor: React.FC<{
  content: Timeline['content'];
  onCancel: () => void;
  onConfirm: (text: Timeline['content']) => void;
}> = ({ content, onCancel, onConfirm }) => {
  const [form, setForm] = React.useState(content);

  return (
    <Window
      draggable={false}
      resizable={false}
      modal={true}
      onClose={onCancel}
      className={'shadow'}
      initialWidth={400}
      initialHeight={420}
      title={'Add Text'}>
      <div>
        <Label style={{ fontSize: '12px' }}>Title</Label>
        <Input
          placeholder={'Enter title...'}
          value={form?.title ?? ''}
          onChange={(e) => setForm((prev) => ({ ...prev, title: e.value }))}
        />
      </div>
      <div>
        <Label style={{ fontSize: '12px' }}>Subtitle</Label>
        <Input
          placeholder={'Enter subtitle...'}
          value={form?.subtitle ?? ''}
          onChange={(e) => setForm((prev) => ({ ...prev, subtitle: e.value }))}
        />
      </div>
      <div>
        <Label style={{ fontSize: '12px' }}>Body</Label>
        <TextArea
          rows={4}
          resizable={'none'}
          placeholder={'Enter body text...'}
          value={form?.body ?? ''}
          onChange={(e) => setForm((prev) => ({ ...prev, body: e.value }))}
        />
      </div>
      <WindowActionsBar>
        <Button themeColor={'secondary'} onClick={onCancel}>
          Cancel
        </Button>
        <Button themeColor={'primary'} onClick={() => onConfirm(form)}>
          Save
        </Button>
      </WindowActionsBar>
    </Window>
  );
};

export const TimelineDurationEditor: React.FC<{
  duration: number;
  isVideo: boolean;
  onCancel: () => void;
  onConfirm: (duration: number) => void;
}> = ({ duration, isVideo, onCancel, onConfirm }) => {
  const [durationValue, setDurationValue] = React.useState(duration);

  return (
    <Window
      modal={true}
      draggable={false}
      resizable={false}
      minimizeButton={undefined}
      maximizeButton={undefined}
      onClose={onCancel}
      className={'shadow'}
      initialWidth={400}
      initialHeight={250}
      title={'Update Duration'}>
      <div>
        <Label style={{ fontSize: '12px' }}>Duration (seconds)</Label>
        <Input
          type={'number'}
          min={0}
          {...(isVideo && {
            max: duration
          })}
          value={durationValue}
          onChange={(e) => setDurationValue(parseInt(e.value))}
        />
        {isVideo && durationValue > duration && (
          <Error>Max duration of this video is {duration} seconds</Error>
        )}
      </div>
      <WindowActionsBar>
        <Button themeColor={'secondary'} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          themeColor={'primary'}
          onClick={() => onConfirm(durationValue)}
          {...(isVideo && {
            disabled: durationValue > duration
          })}>
          Save
        </Button>
      </WindowActionsBar>
    </Window>
  );
};
